import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Col } from "components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestion,
  faSignInAlt,
  faSignOutAlt,
  faDiagramProject,
  faCircleInfo,
  faScreenUsers,
  faCircleX,
  faCheckCircle,
  faCommentAlt,
  faUser,
  faExternalLink,
  faCheckSquare,
  faFlag,
  faFile,
  faPaperPlane,
} from "@fortawesome/pro-regular-svg-icons";

import styles from "../Task.module.css";
import { RowItem } from "components/Nimbiv2/styled";
import styled from "styled-components";
import moment from "moment";
import useTranslationLocal from "hooks/useTranslationLocal";
import { useTranslation } from "react-i18next";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Channels } from "utils/constants";
import {
  faEnvelope,
  faNoteSticky,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faMessageLines } from "@fortawesome/pro-regular-svg-icons";
import PreviewComponent from "../detail/PreviewComponent";
import { getGlobalConfig } from "utils";

const TaskHistory = ({ student, task }) => {
  const { t } = useTranslation();
  const { translation } = useTranslationLocal();
  if (!task) return null;
  let subject = null;
  let channel = null;
  //let responseCode = null;
  let emailStatus = null;
  let dateInfo = null;
  let icon = faQuestion;
  let iconSVG;
  let isChannel = false;
  let borderColor = "#3AC8AC";
  let description = null;
  let momentName = null;
  let referred_from = null;
  let isMoment = null;
  let objetive = null;
  let note = null;
  let state = null;
  let topic = null;
  let sub_topic = null;
  let with_notification = null;
  let notification_email = null;
  let management_type = null;
  let textColor;
  let isExternal;
  let load_massive;

  const emailStatusChoices = {
    opened: t("opened"),
    delivered: t("delivered"),
    "{'queued'}": t("queued"),
    queued: t("queued"),
    sent: t("sent"),
    clicked: t("clicked"),
    bounced: t("bounced"),
    complained: t("sent_to_spam"),
    read: t("read"),
    accepted: t("accepted"),
    replied: t("replied"),
    selected: t("selected"),
  };

  const emailStatusIcons = {
    opened: faCheckCircle,
    delivered: faCheckCircle,
    "{'queued'}": faCheckCircle,
    queued: faCheckCircle,
    sent: faCheckCircle,
    clicked: faCheckCircle,
    bounced: faCircleX,
    complained: faCircleX,
    read: faCheckCircle,
    accepted: faCheckCircle,
    replied: faCheckCircle,
    selected: faCheckCircle,
  };

  const emailStatusColors = {
    opened: "#00B098",
    delivered: "#00B098",
    "{'queued'}": "#00B098",
    queued: "#00B098",
    sent: "#00B098",
    clicked: "#00B098",
    bounced: "#E23232",
    complained: "#E23232",
    read: "#00B098",
    accepted: "#00B098",
    replied: "#00B098",
    selected: "#00B098",
  };

  const iconsChannel = {
    Call: faPhone,
    Email: faEnvelope,
    WhatsApp: faWhatsapp,
    Blackboard: faMessageLines,
  };

  if (task.type === "task") {
    subject =
      task.contact_reason === "Correo Masivo"
        ? task.contact_reason + " / " + task.email_template.name
        : task.contact_reason;
    channel = task.channel;
    //responseCode = task.call_response?.code;
    emailStatus = task.email_status;
    dateInfo = task.closed_at;
    description = task.course_name;
    momentName = task?.moment_name ?? task?.initiative_name;
    isMoment = task?.moment_name ? true : false;
    icon = _.get(iconsChannel, task.channel, faPhone);
    borderColor = "#334FFF";
    isChannel = true;
    textColor = "#334FFF";
  } else if (task.type.includes("moment")) {
    objetive = task.contact_reason;
    dateInfo = task.created_at;
    description = task.course_name;
    referred_from = task.referred_from;
    icon = task.type.includes("start") ? faSignInAlt : faSignOutAlt;
    borderColor = "#D7F5EF";
    textColor = "#06B793";
    if (task.type.includes("re_start")) {
      borderColor = "#FFF2DD";
      textColor = "#B2840D";
      subject = `${t("re_entrance_to")} ${task.name}`;
      iconSVG = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
        >
          <path
            d="M6.50156 3C6.89939 3 7.28092 2.84196 7.56222 2.56066C7.84353 2.27936 8.00156 1.89782 8.00156 1.5C8.00156 1.10218 7.84353 0.720644 7.56222 0.43934C7.28092 0.158035 6.89939 0 6.50156 0C6.10374 0 5.72221 0.158035 5.4409 0.43934C5.1596 0.720644 5.00156 1.10218 5.00156 1.5C5.00156 1.89782 5.1596 2.27936 5.4409 2.56066C5.72221 2.84196 6.10374 3 6.50156 3ZM4.43281 8.33125L5.36719 5.525C5.60781 5.5625 5.83594 5.6375 6.04531 5.74687C6.04219 5.75625 6.03906 5.76875 6.03594 5.77812L5.02344 9.01875L4.51094 8.60312C4.42969 8.5375 4.39844 8.42813 4.43281 8.33125ZM6.27656 10.0375L7.16719 7.18437L7.49531 8.33125C7.55469 8.53438 7.66406 8.72188 7.81406 8.87187L8.72031 9.78125C9.01406 10.075 9.48906 10.075 9.77969 9.78125C10.0703 9.4875 10.0734 9.0125 9.77969 8.72188L8.91719 7.85938L8.57656 6.66875C8.12969 5.0875 6.68594 4 5.04219 4H4.88906C4.38594 4 3.88594 4.08125 3.40781 4.24062C2.16094 4.65625 1.14531 5.57812 0.610937 6.78125L0.314062 7.44688C0.145312 7.825 0.317187 8.26875 0.695312 8.4375C1.07344 8.60625 1.51719 8.43437 1.68594 8.05625L1.98281 7.39062C2.32344 6.625 2.94844 6.02813 3.72031 5.72188L3.00781 7.85625C2.77656 8.54688 2.99844 9.30937 3.56406 9.76875L6.82656 12.4187L7.51719 15.4187C7.61094 15.8219 8.01406 16.075 8.41719 15.9812C8.82031 15.8875 9.07344 15.4844 8.97969 15.0813L8.27031 12C8.20781 11.7281 8.05781 11.4875 7.83906 11.3094L6.27344 10.0375H6.27656ZM3.11719 10.6938L2.36094 12.5781L0.220312 14.7188C-0.0734375 15.0125 -0.0734375 15.4875 0.220312 15.7781C0.514062 16.0688 0.989063 16.0719 1.27969 15.7781L3.45781 13.6C3.57656 13.4813 3.67031 13.3375 3.73594 13.1812L4.33594 11.6812L3.11719 10.6906V10.6938ZM13.9703 14.0312C14.2641 14.325 14.7391 14.325 15.0297 14.0312C15.3203 13.7375 15.3234 13.2625 15.0297 12.9719L13.8109 11.7531H15.1266C17.8203 11.7531 20.0016 9.57187 20.0016 6.87813C20.0016 4.18438 17.8203 2.00312 15.1266 2.00312L10.7516 2C10.3359 2 10.0016 2.33437 10.0016 2.75C10.0016 3.16563 10.3359 3.5 10.7516 3.5H15.1266C16.9891 3.5 18.5016 5.0125 18.5016 6.875C18.5016 8.7375 16.9891 10.25 15.1266 10.25H13.8109L15.0297 9.03125C15.3234 8.7375 15.3234 8.2625 15.0297 7.97188C14.7359 7.68125 14.2609 7.67813 13.9703 7.97188L11.4703 10.4719C11.1766 10.7656 11.1766 11.2406 11.4703 11.5312L13.9703 14.0312Z"
            fill="#B3840D"
          />
        </svg>
      );
    } else if (task.type.includes("start")) {
      subject = `${translation("entrance_to", "startCase", t("entrance_to"))} ${
        task.name
      }`;
      iconSVG = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_1680_50304)">
            <path
              d="M8.5 3C8.89782 3 9.27936 2.84196 9.56066 2.56066C9.84196 2.27936 10 1.89782 10 1.5C10 1.10218 9.84196 0.720644 9.56066 0.43934C9.27936 0.158035 8.89782 0 8.5 0C8.10218 0 7.72064 0.158035 7.43934 0.43934C7.15804 0.720644 7 1.10218 7 1.5C7 1.89782 7.15804 2.27936 7.43934 2.56066C7.72064 2.84196 8.10218 3 8.5 3ZM5.66563 3.39375C5.22813 3.28437 4.76875 3.28437 4.33125 3.39375L4.275 3.40937C3.85938 3.5125 3.475 3.7125 3.15313 3.99062L1.7625 5.18125C1.44688 5.45 1.4125 5.925 1.68125 6.2375C1.95 6.55 2.425 6.5875 2.7375 6.31875L4.12813 5.125C4.275 5 4.45 4.90938 4.6375 4.8625L4.69375 4.84688C4.89375 4.79688 5.1 4.79688 5.3 4.84688L5.56875 4.9125L4.54688 7.975C4.28125 8.77188 4.61875 9.64375 5.35 10.0531L8.1 11.6L7.03438 15.025C6.90938 15.4219 7.13125 15.8406 7.525 15.9656C7.91875 16.0906 8.34062 15.8688 8.46562 15.4719L9.59375 11.8594C9.76875 11.2969 9.52812 10.6875 9.0125 10.3969L8.00937 9.83438L8.8875 7.19688L9.0625 7.76562C9.2875 8.5 9.96562 9 10.7344 9H11H11.5156H12.25C12.6656 9 13 8.66562 13 8.25C13 7.83437 12.6656 7.5 12.25 7.5H11.5031C11.5406 4.90938 11.8594 3.29688 12.2563 2.375C12.6438 1.47812 12.9563 1.49688 12.9969 1.5H13H13.0031C13.0437 1.49688 13.3562 1.47812 13.7437 2.375C14.1656 3.35625 14.5 5.11562 14.5 8C14.5 10.8844 14.1656 12.6438 13.7437 13.625C13.3562 14.5219 13.0437 14.5031 13.0031 14.5H13H12.9969C12.9563 14.5031 12.6438 14.5219 12.2563 13.625C11.9406 12.8938 11.675 11.7344 11.5625 10H11H10.0594C10.3344 14.3969 11.5469 16 13 16C14.6562 16 16 13.9187 16 8C16 2.08125 14.6562 0 13 0C11.5562 0 10.35 1.58125 10.0656 5.90938L9.88437 5.31875C9.70312 4.73438 9.23125 4.28438 8.6375 4.13438L5.66875 3.39375H5.66563ZM7.87813 5.49375L6.68125 9.0875L6.0875 8.75313C5.98438 8.69375 5.93438 8.56875 5.97188 8.45625L7.03125 5.28125L7.87813 5.49375ZM3.82812 9.90938L3.23125 11.5H0.75C0.334375 11.5 0 11.8344 0 12.25C0 12.6656 0.334375 13 0.75 13H3.40313C3.925 13 4.39062 12.6781 4.57188 12.1906L5.0125 11.0156L4.85938 10.9281C4.41875 10.6781 4.06563 10.325 3.82812 9.90938Z"
              fill="#0EA480"
            />
          </g>
          <defs>
            <clipPath id="clip0_1680_50304">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    } else {
      subject = `${translation("output_of", "startCase", t("output_of"))} ${
        task.name
      }`;
      iconSVG = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_1680_50218)">
            <path
              d="M2.25625 13.625C1.83437 12.6438 1.5 10.8875 1.5 8C1.5 5.1125 1.83437 3.35625 2.25625 2.375C2.64375 1.47812 2.95625 1.49688 2.99688 1.5H3H3.00312C3.04375 1.49688 3.35625 1.47812 3.74375 2.375C4.16563 3.35625 4.5 5.11562 4.5 8C4.5 9.42813 4.41875 10.5813 4.28438 11.5H3.75C3.33437 11.5 3 11.8344 3 12.25C3 12.6656 3.33437 13 3.75 13H3.96875H5.52187H6.40312C6.925 13 7.39062 12.6781 7.57188 12.1906L8.0125 11.0156L7.85938 10.9281C7.41875 10.6781 7.06563 10.325 6.82812 9.90938L6.23125 11.5H5.8C5.93125 10.5219 6 9.3625 6 8C6 7.33125 5.98438 6.7125 5.95 6.1375L7.12813 5.125C7.275 5 7.45 4.90938 7.6375 4.8625L7.69375 4.84688C7.89375 4.79688 8.1 4.79688 8.3 4.84688L8.56875 4.9125L7.54688 7.975C7.28125 8.77188 7.61875 9.64375 8.35 10.0531L11.1 11.6L10.0344 15.025C9.90938 15.4219 10.1312 15.8406 10.5281 15.9656C10.925 16.0906 11.3438 15.8688 11.4688 15.4719L12.5938 11.8594C12.7688 11.2969 12.5281 10.6875 12.0125 10.3969L11.0094 9.83438L11.8875 7.19688L12.0625 7.76562C12.2906 8.5 12.9688 9 13.7375 9H15.25C15.6656 9 16 8.66562 16 8.25C16 7.83437 15.6656 7.5 15.25 7.5H13.7375C13.6281 7.5 13.5312 7.42812 13.5 7.325L12.8844 5.31875C12.7031 4.73438 12.2312 4.28438 11.6375 4.13438L8.66875 3.39375C8.23125 3.28437 7.77187 3.28437 7.33437 3.39375L7.27812 3.40937C6.8625 3.5125 6.47813 3.7125 6.15625 3.99062L5.77187 4.3125C5.32188 1.1875 4.25 0 3 0C1.34375 0 0 2.08125 0 8C0 13.9187 1.34375 16 3 16C3.875 16 4.6625 15.4187 5.20937 14H3.55938C3.2625 14.5156 3.0375 14.5031 3.00312 14.5H3H2.99688C2.95625 14.5031 2.64375 14.5219 2.25625 13.625ZM11.5 3C11.8978 3 12.2794 2.84196 12.5607 2.56066C12.842 2.27936 13 1.89782 13 1.5C13 1.10218 12.842 0.720644 12.5607 0.43934C12.2794 0.158035 11.8978 0 11.5 0C11.1022 0 10.7206 0.158035 10.4393 0.43934C10.158 0.720644 10 1.10218 10 1.5C10 1.89782 10.158 2.27936 10.4393 2.56066C10.7206 2.84196 11.1022 3 11.5 3ZM10.8781 5.49375L9.68125 9.0875L9.0875 8.75313C8.98438 8.69375 8.93437 8.56875 8.97188 8.45625L10.0312 5.28125L10.8781 5.49375Z"
              fill="#0EA480"
            />
          </g>
          <defs>
            <clipPath id="clip0_1680_50218">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    }
  } else if (task.type === "note") {
    subject = task?.is_starring
      ? translation(
          "added_starred_observation",
          "startCase",
          t("added_starred_observation")
        )
      : translation("added_observation", "startCase", t("added_observation"));
    dateInfo = task.created_at;
    icon = faNoteSticky;
    note = `${task.note.substring(0, 50)}${task.note.length > 50 ? "..." : ""}`;
    borderColor = "#E8F0FC";
    textColor = "#2A3B53";
  } else if (task.type === "external_management") {
    subject = translation(
      "external_management_single",
      "startCase",
      t("external_management")
    );
    dateInfo = task.created_at;
    icon = faExternalLink;
    channel = task.channel;
    state = task.management_state;
    topic = task.management_topic;
    sub_topic = task.management_subtopic;
    description = task.course_name;
    management_type = task.management_type;
    with_notification = task.with_notification;
    notification_email = task.notification_email;
    isExternal = true;
    load_massive = task?.load_massive;

    note = `${task.comment.substring(0, 500)}${
      task.comment.length > 500 ? "..." : ""
    }`;
    borderColor = "#E8F0FC";
    textColor = "#2A3B53";
  }

  return (
    <>
      {task && (
        <>
          {isChannel && (
            <CardItemHistory
              className={`${styles.historyItem} no-gutters d-none d-sm-flex`}
              style={{ height: "40px" }}
            >
              <Col md={3} style={{ paddingRight: "10px" }}></Col>
              <Col className={styles.colSeparator} md={2}>
                <div className={`${styles.separatorBar}`}>
                  <IconContainerBorder
                    background={borderColor}
                  ></IconContainerBorder>
                </div>
              </Col>
              <Col md={7} style={{ paddingLeft: "10px" }}></Col>
            </CardItemHistory>
          )}
          <CardItemHistory
            ischannel={isChannel ? 1 : 0}
            className={` ${styles.historyItem} no-gutters mt-2 mt-sm-0`}
          >
            <Col md={3} style={{ paddingRight: "10px" }}>
              <div
                className="d-block d-sm-none"
                style={{ paddingLeft: "10px" }}
              >
                <IconContainerBorder
                  ischannel={isChannel ? 1 : 0}
                  background={borderColor}
                  style={{ marginLeft: "0px" }}
                >
                  <IconSepBorder background={isChannel ? null : "transparent"}>
                    <IconSepCenter background={isChannel ? null : borderColor}>
                      {!iconSVG && icon && (
                        <FontAwesomeIcon
                          className={`${styles.iiiiconStyle}`}
                          icon={icon}
                          style={{ fontSize: "20px" }}
                          color={textColor}
                        />
                      )}
                      {iconSVG && <span>{iconSVG}</span>}
                    </IconSepCenter>
                  </IconSepBorder>
                </IconContainerBorder>
              </div>
              <div style={{ marginTop: "31px", heigth: "100%" }}>
                <TextTitleDate color={textColor}>
                  {moment(dateInfo).format("YYYY-MM-DD")}
                </TextTitleDate>
                <TextSubtitleHour
                  style={{ marginTop: "8px", marginBottom: "40px" }}
                >
                  {moment(dateInfo).format("HH:mm")}
                </TextSubtitleHour>
              </div>
            </Col>
            <Col className={styles.colSeparator + " d-none d-sm-block"} md={2}>
              <div className={`${styles.separatorBar} separator-bar`}>
                <IconContainerBorder
                  ischannel={isChannel ? 1 : 0}
                  background={borderColor}
                >
                  <IconSepBorder background={isChannel ? null : "transparent"}>
                    <IconSepCenter background={isChannel ? null : borderColor}>
                      {!iconSVG && icon && (
                        <FontAwesomeIcon
                          className={`${styles.iiiiconStyle}`}
                          icon={icon}
                          style={{ fontSize: "20px" }}
                          color={textColor}
                        />
                      )}
                      {iconSVG && <span>{iconSVG}</span>}
                    </IconSepCenter>
                  </IconSepBorder>
                </IconContainerBorder>
              </div>
            </Col>
            <ColDesign md={7} style={{ paddingLeft: "10px" }}>
              <div style={{ marginTop: "31px", heigth: "100%" }}>
                <TextTitle>{subject}</TextTitle>
                <div
                  style={{
                    marginTop: "2px",
                  }}
                >
                  {momentName && (
                    <TextItemDetail>
                      <FontAwesomeIcon
                        icon={isMoment ? faDiagramProject : faFlag}
                        style={{ marginRight: "6px" }}
                      />
                      {momentName}
                    </TextItemDetail>
                  )}
                  <div
                    style={
                      isExternal
                        ? {
                            display: "flex",
                            flexWrap: "wrap",
                            columnGap: "12px",
                          }
                        : {}
                    }
                  >
                    {topic && (
                      <TextItemDetail>
                        <span>{_.upperFirst(t("topic"))}</span>: {topic}
                      </TextItemDetail>
                    )}
                    {sub_topic && (
                      <TextItemDetail>
                        <span>{_.upperFirst(t("sub_topic"))}</span>: {sub_topic}
                      </TextItemDetail>
                    )}
                    {management_type && (
                      <TextItemDetail>
                        <span>{_.upperFirst(t("type"))}</span>:{" "}
                        {management_type}
                      </TextItemDetail>
                    )}
                    {state && (
                      <TextItemDetail>
                        <span>{_.upperFirst(t("state"))}</span>: {state}
                      </TextItemDetail>
                    )}
                    {with_notification && notification_email && (
                      <TextItemDetail>
                        <span>
                          {_.upperFirst(t("notify_person_in_charge"))}
                        </span>
                        : {notification_email}
                      </TextItemDetail>
                    )}
                    {with_notification && notification_email == null && (
                      <TextItemDetail>
                        <span>
                          {_.upperFirst(t("notify_person_in_charge"))}
                        </span>
                        : {t("pending_one")}
                      </TextItemDetail>
                    )}
                  </div>
                  {task.contact_number && (
                    <TextItemDetail>
                      <FontAwesomeIcon
                        icon={faPaperPlane}
                        style={{ marginRight: "6px" }}
                      />
                      {_.upperFirst(t("contacted_at"))}: {task.contact_number}
                    </TextItemDetail>
                  )}
                  {description && (
                    <TextItemDetail>
                      <FontAwesomeIcon
                        icon={faScreenUsers}
                        style={{ marginRight: "6px" }}
                      />
                      {translation(
                        "tracking_object",
                        "startCase",
                        "Tracking object"
                      )}
                      : {description}
                    </TextItemDetail>
                  )}
                  {objetive && (
                    <TextItemDetail>
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        style={{ marginRight: "6px" }}
                      />
                      {objetive}
                    </TextItemDetail>
                  )}
                  {load_massive && (
                    <TextItemDetail>
                      <FontAwesomeIcon
                        icon={faFile}
                        style={{ marginRight: "6px" }}
                      />
                      Vía carga masiva
                    </TextItemDetail>
                  )}
                  {task.completed_by && (
                    <TextItemDetail>
                      <FontAwesomeIcon
                        icon={faPhone}
                        style={{ marginRight: "6px" }}
                      />
                      {task.completed_by
                        ? `${task.completed_by.first_name} ${task.completed_by.last_name}`
                        : null}
                    </TextItemDetail>
                  )}
                  {task && task?.enter_reason && (
                    <TextItemDetail>
                      <span>{_.upperFirst(t("enter_reason"))}</span>:{" "}
                      {task.enter_reason}
                    </TextItemDetail>
                  )}
                  {task && task?.referred_to_name && (
                    <TextItemDetail>
                      <span>{_.upperFirst(t("derived_to"))}</span>:{" "}
                      {task?.referred_to_name}
                    </TextItemDetail>
                  )}
                  {task && task?.enter_comment && (
                    <TextItemDetail>
                      <span>{_.upperFirst(t("additional_remarks"))}</span>:{" "}
                      <div
                        dangerouslySetInnerHTML={{ __html: task.enter_comment }}
                      ></div>
                    </TextItemDetail>
                  )}
                  {task.manually_created_by && (
                    <TextItemDetail style={{ color: "#3AC8AC" }}>
                      {task.manually_created_by
                        ? `${t("manually_created_by")}: ${
                            task.manually_created_by.first_name
                          } ${task.manually_created_by.last_name}`
                        : null}
                    </TextItemDetail>
                  )}

                  {referred_from && (
                     <TextItemDetail style={{ color: "#3AC8AC" }}>
                     {_.upperFirst(t("referred_from"))}: {referred_from}
                   </TextItemDetail>
                  )}
                  {task &&
                    task.call_response &&
                    task.call_response.description && (
                      <>
                        <TextItemDetail
                          style={{
                            color: task.call_response.enable_reactions
                              ? "#00B098"
                              : "#E23232",
                            fontWeight: "500",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={
                              task.call_response.enable_reactions
                                ? faCheckCircle
                                : faCircleX
                            }
                            style={{ marginRight: "6px" }}
                          />
                          {_.upperFirst(t("caller"))}:{" "}
                          {task.call_response.description}
                        </TextItemDetail>
                        <TextItemDetail
                          style={{
                            color: task.call_response.enable_reactions
                              ? "#00B098"
                              : "#E23232",
                          }}
                        >
                          {task.call_comment &&
                          task.student_response === null ? (
                            <div
                              style={{
                                fontWeight: "500",
                              }}
                            >
                              {task.call_comment}
                            </div>
                          ) : null}
                        </TextItemDetail>
                      </>
                    )}
                  <div className="d-flex justify-content-between">
                    {emailStatus && emailStatus in emailStatusChoices && (
                      <TextItemDetail
                        style={{
                          color: _.get(
                            emailStatusColors,
                            emailStatus,
                            "#00B098"
                          ),
                          fontWeight: "500",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={_.get(
                            emailStatusIcons,
                            emailStatus,
                            faCheckCircle
                          )}
                          style={{ marginRight: "6px" }}
                        />
                        {emailStatusChoices[emailStatus]}
                      </TextItemDetail>
                    )}
                    {task && task.confirm && (
                      <TextItemDetail
                        style={{
                          color: "#334fff",
                          fontWeight: "500",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faCheckSquare}
                          style={{ marginRight: "6px" }}
                        />
                        {_.upperFirst(t("confirmed"))}
                      </TextItemDetail>
                    )}
                  </div>
                  {task.student_response && channel === "Call" && (
                    <ContainerNote>
                      <TextItemDetail style={{ marginTop: "0px" }}>
                        {task.student_response}{" "}
                        {task.call_comment ? (
                          <span>: {task.call_comment}</span>
                        ) : null}
                      </TextItemDetail>
                    </ContainerNote>
                  )}

                  <div
                    style={
                      isExternal
                        ? {
                            display: "flex",
                            flexWrap: "wrap",
                            columnGap: "12px",
                          }
                        : {}
                    }
                  >
                    {channel && task.type === "external_management" && (
                      <TextItemDetail>
                        {iconsChannel[channel] && (
                          <FontAwesomeIcon
                            icon={iconsChannel[channel]}
                            style={{ marginRight: "6px" }}
                          />
                        )}
                        {_.upperFirst(_.get(Channels, channel, channel))}
                      </TextItemDetail>
                    )}
                    {task.created_by && task.type === "external_management" && (
                      <TextItemDetail>
                        <FontAwesomeIcon
                          icon={faUser}
                          style={{ marginRight: "6px" }}
                        />
                        {task.created_by.first_name} {task.created_by.last_name}
                      </TextItemDetail>
                    )}
                  </div>
                  {note && (
                    <ContainerNote>
                      <TextItemDetail style={{ marginTop: "0px" }}>
                        {task.note ?? note}
                      </TextItemDetail>
                    </ContainerNote>
                  )}
                  {task.questionnaire && (
                    <ContainerNote>
                      <PreviewComponent
                        title={t("quiz_answers")}
                        responseQuestion={task.questionnaire}
                        showTitle={false}
                        inline={true}
                      ></PreviewComponent>
                    </ContainerNote>
                  )}
                  {channel === "WhatsApp" &&
                    task.whatsapp_messages &&
                    task.whatsapp_messages !== "" && (
                      <ContainerNote>
                        <TextItemDetail style={{ marginTop: "0px" }}>
                          <FontAwesomeIcon
                            className="mr-2"
                            icon={faWhatsapp}
                            size="1x"
                          />{" "}
                          {task.whatsapp_messages}
                        </TextItemDetail>
                      </ContainerNote>
                    )}
                  {task.comments && task.comments !== "" && (
                    <ContainerNote>
                      <TextItemDetail style={{ marginTop: "0px" }}>
                        <FontAwesomeIcon
                          className="mr-2"
                          icon={faCommentAlt}
                          size="1x"
                        />{" "}
                        {task.comments}
                      </TextItemDetail>
                    </ContainerNote>
                  )}
                  {getGlobalConfig("enable_second_comment", false) &&
                    task.second_comments &&
                    task.second_comments !== "" && (
                      <ContainerNote>
                        <TextItemDetail style={{ marginTop: "0px" }}>
                          <FontAwesomeIcon
                            className="mr-2"
                            icon={faCommentAlt}
                            size="1x"
                          />{" "}
                          {task.second_comments}
                        </TextItemDetail>
                      </ContainerNote>
                    )}
                </div>
              </div>
            </ColDesign>
          </CardItemHistory>
        </>
      )}
    </>
  );
};

TaskHistory.propTypes = {
  student: PropTypes.shape({}).isRequired,
  task: PropTypes.shape({}).isRequired,
};

export default React.memo(TaskHistory);

const TextTitleDate = styled.div`
  font-family: "Nova";
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-size-lg);
  line-height: 120%;
  text-align: right;
  color: ${(props) => props.color ?? "#334fff"};
`;
const TextSubtitleHour = styled.div`
  font-size: var(--font-size-md);
  font-weight: 325;
  line-height: 140%;
  color: #71819c;
  text-align: right;
`;

const TextTitle = styled.div`
  font-weight: 500;
  font-size: var(--font-size-lg);
  line-height: 120%;
  color: #2a2b2e;
`;

const TextItemDetail = styled.div`
  font-size: var(--font-size-md);
  color: #71819c;
  display: flex;
  align-items: center;
  margin-top: 6px;
  white-space: pre-line;
  span {
    font-weight: bold;
  }
`;

const ContainerNote = styled.div`
  padding: 6px 15px;
  background: linear-gradient(
      0deg,
      rgba(166, 196, 255, 0.2),
      rgba(166, 196, 255, 0.2)
    ),
    #ffffff;
  border-radius: 8px;
  margin-top: 8px;
`;

const CardItemHistory = styled(RowItem)`
  ${(props) =>
    props.ischannel
      ? `border-radius: 12px;
border: 1px solid var(--gray-scale-500, #E8F0FC);
background: #FFF;
box-shadow: 0px 6px 30px 0px rgba(60, 71, 102, 0.05);
padding-bottom: 31px;
.separator-bar{
  border-right:0px;
}
`
      : `
        @media (max-width: 768px) {
    border-radius: 12px;
border: 1px solid var(--gray-scale-500, #E8F0FC);
background: #FFF;
box-shadow: 0px 6px 30px 0px rgba(60, 71, 102, 0.05);
padding-bottom: 31px;
  }`}
`;

const IconSepCenter = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.background ?? "linear-gradient(0deg, #edf1f7, #edf1f7), #ffffff"};
  border-radius: 50%;
  height: 42px;
  width: 42px;
`;

const IconSepBorder = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.background ?? "white"};
  border-radius: 50%;
  height: 48px;
  width: 48px;
`;
const IconContainerBorder = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3ac8ac;
  border-radius: 50%;
  height: 54px;
  margin-left: -26px;
  margin-top: ${(props) => (!props.ischannel ? "23px" : "30px")};
  position: absolute;
  width: 54px;
  ${(props) =>
    !props.ischannel
      ? "background: transparent;"
      : `background: ${props.background};`}
`;

const ColDesign = styled(Col)`
  @media (max-width: 768px) {
    padding-right: 10px !important;
  }
`;
